import { inject, Injectable } from '@angular/core';
import { SetupHandler } from './setup.handler';
import { CONFIG_FONTS } from '@aipb/util/di';

@Injectable({
  providedIn: 'root'
})
export class FontLoaderHandler extends SetupHandler {
  fonts = inject(CONFIG_FONTS);

  constructor() {
    super('font-loader.handler');
  }

  handle() {
    const fonts = this.fonts;

    fonts.forEach((font) => {
      this.addLogMessage(`load font ${font.fontFamily} from ${font.srcUrl} as format ${font.srcFormat}`);
      const style = document.createElement('style');
      style.textContent = `
      @font-face {
        font-family: '${font.fontFamily}';
        src: url('${font.srcUrl}') format('${font.srcFormat}');
      }
    `;
      document.head.appendChild(style);
    });
  }
}
